module.exports = __webpack_public_path__ + "img/LOGO2.6307906e.jpg";